import View from './view';

export const ProfileMobileApplications = View;
